import { render, staticRenderFns } from "./wyfgs.vue?vue&type=template&id=10f3ad44&scoped=true&"
import script from "./wyfgs.vue?vue&type=script&lang=js&"
export * from "./wyfgs.vue?vue&type=script&lang=js&"
import style0 from "./wyfgs.vue?vue&type=style&index=0&id=10f3ad44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f3ad44",
  null
  
)

export default component.exports